import type { IPuzzlesRepository } from '@domain/usecases/puzzles/PuzzlesRepository';
import { FirestoreClientPuzzleRepository } from '@infrastructure/firebase/client/firestore/FirestoreClientPuzzleRepository';

export const makePuzzleRepository = (): IPuzzlesRepository => {
	return new FirestoreClientPuzzleRepository();
};
